import React from "react";
import rays from "../../assets/icons/rays.webp";
import RegForm from "../../components/cons_reg/RegForm";
import RegisterTitle from "../../components/CommonTitle";
import DateAndTimeBar from "../../components/DateAndTimeBar";

const ConsumptionRegister = () => {
  return (
    <div className="w-full h-full bg-light-green  flex flex-col">
      <RegisterTitle
        img={rays}
        title={"Registro de consumo hídrico y eléctrico."}
        text={
          "Se establece la programación de consumo hídrico y eléctrico de las orquídeas Phalaenopsis."
        }
      />

      <DateAndTimeBar />
      <div className="flex w-full justify-center bg-light-green h-fit">
        <div className="flex flex-wrap max-w-[1280px] w-full justify-center md:p-6 h-full">
          <RegForm type={"Agua"} />
          <RegForm type={"Luz"} />
        </div>
      </div>
    </div>
  );
};

export default ConsumptionRegister;
